module.exports = __webpack_public_path__ + "static/img/logo.a04d717.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home_model/logo.png
// module id = X8+r
// module chunks = 0